import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  Bus: {
    to_address: '',
    date_expire_time: '',
    at_address: '',
    bus_company_name: ''
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
